// extracted by mini-css-extract-plugin
export default {"info":"SiteInfo_info__OGn30","info__schedule":"SiteInfo_info__schedule__W68Au","info__phone":"SiteInfo_info__phone__NMpHI"};